import { Card, CardContent } from '@/components/ui/card'
import { Plane, Truck } from 'lucide-react'
import { useTranslation } from 'react-i18next'

export function ModeSoon({ mode }: { mode: 'air' | 'road' }) {
  const { t } = useTranslation('freight')
  const Icon = mode === 'air' ? Plane : Truck
  return (
    <div className="mx-auto flex w-full max-w-3xl flex-col gap-6 px-4 py-6 md:px-6">
      <div>
        <h1 className="font-display text-3xl font-bold tracking-tight">
          {t(`soon.${mode}.title`)}
        </h1>
        <p className="mt-1 text-sm text-muted-foreground">{t(`soon.${mode}.subtitle`)}</p>
      </div>
      <Card>
        <CardContent className="flex flex-col items-start gap-3 p-6">
          <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-muted text-muted-foreground">
            <Icon className="h-5 w-5" />
          </div>
          <p className="text-sm text-muted-foreground">{t(`soon.${mode}.body`)}</p>
        </CardContent>
      </Card>
    </div>
  )
}
